import CancelCircle from '../../src/legacy/CancelCircle';
export default CancelCircle;
